import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

import { INFO_LEVELS } from './workflow-meta/core/interface';

@Pipe({
  name: 'infoLevelColor',
  standalone: true,
})
export class InfoLevelColorPipe implements PipeTransform {
  map = {
    [INFO_LEVELS.Error]: 'red',
    [INFO_LEVELS.Warning]: 'orange',
    [INFO_LEVELS.Info]: 'grayMedium',
    [INFO_LEVELS.Success]: 'green',
  };

  transform(value: string): string {
    return get(this.map, value, 'grayMedium');
  }
}
